import { useTranslation } from 'react-i18next';
import { AutoScroll, useEmblaCarousel } from '@/ui/components/carousel';

export const UnforgattableEvents = () => {
  const { t } = useTranslation();

  return (
    <section className='w-full pt-xs pb-24 md:py-xl md:pb-[5.375rem] flex flex-col gap-xl'>
      <div className='w-full flex flex-col gap-xl text-center'>
        <header className='w-full max-w-[75rem] mx-auto flex flex-col gap-xl items-center px-mini md:mb-xl'>
          <img src='/svg/logoLinka.svg' width={115} height={38} alt={t('linka-events')} />

          <h2 className='ts-heading-xl md:ts-heading-display text-[#18181b] text-center max-w-[60rem] mx-auto'>
            {t('home.unforgettable-events.title')}
          </h2>

          <p className='ts-subtitle-sm text-[#51525c]'>{t('home.unforgettable-events.description')}</p>
        </header>

        <UnforgattableEventsCarrousel />
      </div>
    </section>
  );
};

const UnforgattableEventsCarrousel = () => {
  const [emblaRef] = useEmblaCarousel(
    {
      align: 'start',
      containScroll: false,
      loop: true,
    },
    [AutoScroll({ playOnInit: true, stopOnInteraction: false })],
  );

  return (
    <div className='embla w-full'>
      <div className='embla__viewport overflow-hidden' ref={emblaRef}>
        <div className='embla__container flex'>
          {items.map((item) => (
            <div
              className='embla__slide min-w-[12.5rem] mr-xxs max-w-[12.5rem] h-[6.25rem] md:min-w-[20.625rem] md:max-w-[20.625rem] md:h-[10.312rem] rounded-md'
              key={item.src}
            >
              <img className='size-full' src={item.src} alt='' />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const items: {
  src: string;
}[] = [
  {
    src: '/webp/unforgattable-events/1.webp',
  },
  {
    src: '/webp/unforgattable-events/2.webp',
  },
  {
    src: '/webp/unforgattable-events/3.webp',
  },
  {
    src: '/webp/unforgattable-events/4.webp',
  },
  {
    src: '/webp/unforgattable-events/5.webp',
  },
  {
    src: '/webp/unforgattable-events/6.webp',
  },
  {
    src: '/webp/unforgattable-events/7.webp',
  },
  {
    src: '/webp/unforgattable-events/8.webp',
  },
  {
    src: '/webp/unforgattable-events/9.webp',
  },
  {
    src: '/webp/unforgattable-events/10.webp',
  },
  {
    src: '/webp/unforgattable-events/11.webp',
  },
  {
    src: '/webp/unforgattable-events/12.webp',
  },
  {
    src: '/webp/unforgattable-events/13.webp',
  },
  {
    src: '/webp/unforgattable-events/14.webp',
  },
];
